






import { Component, Vue } from 'vue-property-decorator';
import _, { List } from 'underscore';
import { auth, db } from './../firebase';
import { AdvancedBloomFilter } from '@pixi/filter-advanced-bloom';
import * as PIXI from 'pixi.js';
import * as PIXIS from 'pixi-sound';

interface User {
  totalPoint: number;
  surpriseVote: string;
  impressionVote: string;
  techVote: string;

}
@Component
export default class Game extends Vue {
  public users: User[] = [];
  public meta = {isOpen: true};
  private createdPromise: Promise<void>;
  private PIXIApp?: PIXI.Application;
  private trophy?: PIXI.Texture;
  private win?: PIXI.Sprite;


  public data() {
    return {
      users: undefined,
      meta: undefined,
    };
  }

  public created() {
    const metaRef = db.ref('meta');
    const usersRef = db.ref('users');
    this.createdPromise = new Promise(async (resolve, reject) => {
      console.log('count: bind metaRef');
      await this.$rtdbBind('meta', metaRef);
      console.log('count: bind userRef');
      await this.$rtdbBind('users', usersRef);
      resolve();
    });
  }

  public mounted() {
    this.createdPromise
      .then(() => {
        console.log('ok');
      })
      .catch((e) => {
        console.error(e);
      });
    const canvas = this.$refs.gameCanvas as HTMLCanvasElement;
    console.log('count:mounted()', canvas);
    this.PIXIApp = new PIXI.Application({
      width: canvas.offsetWidth,
      height: canvas.offsetHeight,
      view: canvas,
      antialias: true,
      transparent: false,
    });
    const trophyUrl = require('./../assets/images/trophy.png');
    this.trophy = PIXI.Texture.from(trophyUrl);
    this.win = new PIXI.Sprite(this.trophy);
    this.win.anchor.set(0.5);
    this.win.scale.set(0.5, 0.5);
    this.win.x = 400;
    this.PIXIApp.stage.addChild(this.win);
    console.log(this.win);
  }

  get teams() {
      const surprisePoints = _.pluck(this.users, 'surpriseVote');
      const impressionPoints = _.pluck(this.users, 'impressionVote');
      const techPoints = _.pluck(this.users, 'techVote');
      const teamPoints = [];
      const teamLabel = 'ABCDEFG';
      for (let i = 0; i < teamLabel.length; i++) {
        teamPoints[i] = {
          teamId: `Party ${teamLabel[i]}`,
          surprisePoint: _.filter(surprisePoints, (p) => p === (i + 1).toString())
            .length,
          impressionPoint: _.filter(
            impressionPoints,
            (p) => p === (i + 1).toString(),
          ).length,
          techPoint: _.filter(techPoints, (p) => p === (i + 1).toString()).length,
          totalPoint: 0,
        };
      }
      for (let i = 0; i < teamLabel.length; i++) {
        const teamPoint = teamPoints[i];
        teamPoints[i].totalPoint =
          teamPoint.surprisePoint +
          teamPoint.impressionPoint +
          teamPoint.techPoint;
      }
      return teamPoints;
    }

  get isOpen() {
      console.log('count:isOpen', this.meta);
      return this.meta ? this.meta.isOpen : false;
    }

  get  userNum() {
      if (this.users) {
        return Object.keys(this.users).length;
      } else {
        return 0;
      }
    }

  get votedUserNum() {
      const votedUsers = _.filter(
        this.users,
        (user) =>
          user.surpriseVote !== undefined &&
          user.impressionVote !== undefined &&
          user.techVote !== undefined,
      );
      return votedUsers.length;
  }
}
